<template>
  <div
    aria-labelledby="modal-title"
    aria-modal="true"
    class="fixed z-50 inset-0 overflow-y-auto"
    data-testId="modal-dialog"
    role="dialog"
  >
    <div
      class="
        flex
        items-end
        justify-center
        min-h-screen
        pt-4
        px-4
        pb-20
        text-center
        sm:block
        sm:p-0
        m-10
      "
    >
      <div
        aria-hidden="true"
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      ></div>
      <span
        aria-hidden="true"
        class="hidden sm:inline-block sm:align-middle"
        :class="{ 'sm:h-screen': !fullWidth }"
        >&#8203;</span
      >
      <div
        class="
          inline-table
          bg-white
          rounded
          text-left
          overflow-scroll
          shadow-xl
          transform
          transition-all
          align-middle
          w-full
        "
        :class="{
          'max-w-lg my-8': !fullWidth && !large,
          'max-w-4xl my-8': large,
        }"
      >
        <div class="p-4 sm:p-6">
          <div
            class="
                mt-3
                text-center
                sm:mt-0
                sm:text-left
                flex
                justify-between
                w-full
                items-start
              "
            data-testid="heading-row"
          >
            <div class="flex flex-col">
              <div class="flex flex-row">
                <slot name="heading-icon" />
                <h3 id="modal-title" class="font-bold text-lg pt-1 text-black">
                  {{ heading }}
                </h3>
              </div>
              <h4 v-if="subheading" class="mt-1 font-bold">
                {{ subheading }}
              </h4>
            </div>
            <Cross
              v-if="!hideCloseButton"
              class="flex w-5 h-5 cursor-pointer text-primary"
              data-testid="close-button"
              @click="emitClose"
            />
          </div>
          <slot name="body" />
        </div>
        <div
          v-if="hasActionButtons"
          class="px-4 py-4 sm:px-6 sm:flex sm:flex-row-reverse"
        >
          <slot name="action-buttons" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import Cross from '@/components/icons/Cross.vue';

export default defineComponent({
  name: 'Modal',
  emits: ['close-model'],
  components: { Cross },
  props: {
    heading: {
      type: String,
      default: '',
    },
    subheading: {
      type: String,
      default: '',
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit, slots }) {
    const emitClose = () => {
      emit('close-model');
    };

    const hasActionButtons = ref(false);

    onMounted(() => {
      hasActionButtons.value = slots['action-buttons'] ? true : false;
    });

    return { emitClose, hasActionButtons };
  },
});
</script>
